/** FAQ, Support, and Advertising page copy (Brazilian Portuguese translation). */
export const pagesMessagesPt = {
  faq: {
    pageTitle: "Perguntas Frequentes",
    pageSubtitle: "Encontre respostas para as perguntas mais comuns sobre o WasOK",
    seoTitle: "Perguntas Frequentes — WasOK",
    seoDescription:
      "Respostas para perguntas comuns sobre o WasOK, escaneamento de produtos, privacidade e avaliações.",
    items: [
      {
        question: "Como o WasOK funciona?",
        answer:
          "O WasOK ajuda você a lembrar quais produtos gostou ou não gostou ao escanear códigos de barras e salvar suas avaliações e anotações. Basta escanear o código de barras de um produto, avaliá-lo, adicionar anotações e, na próxima vez que escanear o mesmo produto, você verá instantaneamente sua avaliação anterior.",
      },
      {
        question: "Meus dados são armazenados na nuvem?",
        answer:
          "Não! Todos os seus dados são armazenados localmente no seu dispositivo. Não sincronizamos suas informações com a nuvem, o que significa que seu histórico de compras e opiniões sobre produtos permanecem completamente privados. No entanto, isso também significa que você deve fazer backup do seu dispositivo se quiser preservar seus dados.",
      },
      {
        question: "Preciso de conexão com a internet para usar o WasOK?",
        answer:
          "Não, o WasOK funciona completamente offline. Como todos os seus dados são armazenados localmente no dispositivo, você pode escanear produtos, adicionar avaliações e ver seu histórico sem nenhuma conexão com a internet.",
      },
      {
        question: "Posso usar o WasOK para qualquer tipo de produto?",
        answer:
          "Sim! O WasOK funciona com qualquer produto que tenha um código de barras. Seja alimento, cosmético, item de casa, eletrônico ou qualquer outra coisa com código de barras, você pode escaneá-lo e salvar suas opiniões.",
      },
      {
        question: "Como faço para escanear um código de barras?",
        answer:
          "Basta abrir o app WasOK e tocar no botão de escanear. Aponte a câmera para o código de barras do produto, e o app irá detectá-lo e escaneá-lo automaticamente. Certifique-se de que o código de barras esteja bem iluminado e em foco para obter os melhores resultados.",
      },
      {
        question: "Posso adicionar fotos às minhas avaliações de produtos?",
        answer:
          "Sim! Você pode anexar fotos a qualquer avaliação de produto. Isso é especialmente útil para lembrar detalhes da embalagem, listas de ingredientes ou qualquer outra informação visual que possa ajudá-lo a lembrar por que gostou ou não gostou de um produto.",
      },
      {
        question: "Quais informações posso salvar sobre os produtos?",
        answer:
          "Você pode salvar avaliações (1 a 5 estrelas), anotações de texto, fotos, o preço que pagou, onde comprou e categorias personalizadas. Essas informações abrangentes ajudam você a tomar decisões informadas na hora de comprar.",
      },
      {
        question: "Posso criar listas de compras?",
        answer:
          "Sim! O WasOK permite criar listas de compras a partir de produtos que você já avaliou. Isso facilita lembrar quais produtos você adorou e quer comprar novamente.",
      },
      {
        question: "Como organizo meus produtos?",
        answer:
          "Você pode organizar produtos usando categorias personalizadas. Por exemplo, você pode criar categorias como 'Snacks', 'Café', 'Skincare' ou 'Produtos de Limpeza'. Isso facilita navegar pelas suas avaliações por tipo.",
      },
      {
        question: "O WasOK é gratuito?",
        answer:
          "Sim, o WasOK é totalmente gratuito para baixar e usar. Não há compras dentro do app, assinaturas ou taxas ocultas. Acreditamos que todos deveriam ter acesso a uma forma privada de lembrar suas preferências de produtos.",
      },
      {
        question: "O WasOK é acessível?",
        answer:
          "O WasOK foi projetado para ser utilizável pelo maior número possível de pessoas. O app inclui recursos de acessibilidade, como suporte a leitor de tela, texto escalável e um modo opcional de alto contraste.",
      },
      {
        question: "O que acontece se eu desinstalar o app?",
        answer:
          "Como todos os dados são armazenados localmente no seu dispositivo, desinstalar o app apagará todas as suas avaliações de produtos, anotações e listas de compras. Certifique-se de exportar seus dados se quiser manter um backup antes de desinstalar.",
      },
      {
        question: "Posso exportar meus dados?",
        answer:
          "Sim, o WasOK permite exportar seus dados para fins de backup. Você pode exportar todas as suas avaliações para um arquivo que pode salvar no seu dispositivo ou no serviço de armazenamento em nuvem de sua escolha.",
      },
      {
        question: "O WasOK rastreia minha localização?",
        answer:
          "Não, o WasOK não rastreia sua localização. Embora você possa inserir manualmente o nome da loja onde comprou um produto, o app não usa GPS ou serviços de localização.",
      },
      {
        question: "Posso usar o WasOK em vários dispositivos?",
        answer:
          "Atualmente, o WasOK não sincroniza entre dispositivos, já que todos os dados são armazenados localmente. Cada dispositivo terá seu próprio banco de dados separado de produtos e avaliações.",
      },
      {
        question: "E se um código de barras não escanear?",
        answer:
          "Se um código de barras não escanear, certifique-se de que esteja bem iluminado e em foco. Você também pode tentar limpar a lente da câmera. Se o código de barras estiver danificado ou ilegível, talvez você consiga inserir o número do código de barras manualmente.",
      },
    ],
    cta: {
      heading: "Ainda tem dúvidas?",
      body: "Entre em contato com nossa equipe de suporte — teremos prazer em ajudar.",
      button: "Fale com o suporte",
    },
  },
  support: {
    pageTitle: "Suporte",
    seoTitle: "Suporte — WasOK",
    seoDescription:
      "Obtenha ajuda com o WasOK: entre em contato com o suporte, reporte bugs e compartilhe seu feedback.",
    getHelp: {
      title: "Obter Ajuda",
      body: "Estamos aqui para ajudar você a aproveitar ao máximo o WasOK. Se você está enfrentando problemas ou tem dúvidas, temos vários recursos disponíveis para ajudá-lo.",
    },
    faq: {
      title: "Perguntas Frequentes",
      body: "Antes de entrar em contato, confira nossa seção de Perguntas Frequentes, onde respondemos às dúvidas mais comuns sobre o WasOK. Você encontrará informações detalhadas sobre como o app funciona, privacidade, armazenamento de dados e muito mais.",
    },
    contact: {
      title: "Fale com o Suporte",
      body: "Se você não encontrou a resposta que procurava, nossa equipe de suporte está pronta para ajudar. Você pode nos contatar em:",
      emailLabel: "E-mail:",
      responseTime: "Normalmente respondemos em 24-48 horas",
    },
    bugs: {
      title: "Reportando Bugs",
      body: "Encontrou um bug? Agradecemos sua ajuda para tornar o WasOK melhor. Ao reportar um bug, inclua:",
      items: [
        "Uma descrição detalhada do problema",
        "Passos para reproduzir o problema",
        "O modelo do seu dispositivo e a versão do Android",
        "Capturas de tela ou gravações de tela, se possível",
      ],
      sendPrefix: "Envie relatórios de bugs para:",
    },
    featureRequests: {
      title: "Sugestões de Recursos",
      bodyBefore:
        "Tem uma ideia para um novo recurso? Adoraríamos ouvir você! Envie suas sugestões para",
      bodyAfter:
        ". Embora não possamos implementar todas as solicitações, consideramos cuidadosamente todos os feedbacks ao planejar atualizações futuras.",
    },
    knownIssues: {
      title: "Problemas Conhecidos",
      body: "Atualmente estamos cientes dos seguintes problemas e trabalhando em correções:",
      items: [
        "Alguns códigos de barras podem não escanear em condições de pouca luz — tente usar uma lanterna",
        "Anotações de produtos muito longas podem demorar um pouco para salvar em dispositivos mais antigos",
        "As miniaturas de imagens podem parecer pixeladas em telas de alta resolução",
      ],
    },
    appUpdates: {
      title: "Atualizações do App",
      body: "Lançamos atualizações regularmente com novos recursos, melhorias e correções de bugs. Mantenha o WasOK atualizado através da Google Play Store para receber as últimas melhorias.",
    },
    community: {
      title: "Comunidade",
      body: "Junte-se à nossa comunidade de usuários que estão tomando decisões de compra mais inteligentes com o WasOK. Compartilhe dicas, faça perguntas e conecte-se com outros usuários em nossos canais sociais.",
    },
    emergency: {
      title: "Suporte de Emergência",
      body: 'Se você está enfrentando um problema crítico que impede o uso do app, marque seu e-mail como "URGENTE" no assunto, e daremos prioridade à sua solicitação.',
    },
    cta: {
      heading: "Ainda precisa de ajuda?",
      body: "Nossa equipe de suporte está aqui para você. Não hesite em entrar em contato com quaisquer dúvidas ou preocupações.",
      button: "Enviar E-mail ao Suporte",
    },
  },
  advertising: {
    pageTitle: "Publicidade e Monetização",
    seoTitle: "Publicidade — WasOK",
    seoDescription: "Como o WasOK aborda publicidade e monetização.",
    approach: {
      title: "Nossa Abordagem",
      body: "No WasOK, acreditamos que seus hábitos de compra e opiniões sobre produtos são privados e pessoais. Nosso modelo de negócios reflete esse valor fundamental.",
    },
    noAds: {
      title: "Sem Anúncios",
      body: "O WasOK não exibe nenhum anúncio. Nunca mostraremos anúncios com base nos produtos que você escaneia, nas avaliações que você dá ou em quaisquer outros dados que você criar no app. Sua experiência com o WasOK é completamente livre de anúncios.",
    },
    noDataSelling: {
      title: "Sem Venda de Dados",
      body: "Não vendemos, alugamos ou compartilhamos seus dados com anunciantes, corretores de dados ou terceiros. Como todos os seus dados são armazenados localmente no seu dispositivo, nem nós temos acesso a eles. Suas avaliações de produtos, listas de compras e anotações são só suas.",
    },
    noTracking: {
      title: "Sem Rastreamento",
      body: "O WasOK não usa pixels de rastreamento, serviços de análise ou qualquer outra tecnologia que monitore seu comportamento ou compartilhe informações com terceiros. Não rastreamos quais produtos você escaneia, em quais lojas você compra ou como você usa o app.",
    },
    sustainability: {
      title: "Como Nos Mantemos Sustentáveis",
      body: "Você deve estar se perguntando como mantemos o WasOK gratuito sem anúncios ou venda de dados. Nossa abordagem é simples:",
      items: [
        {
          label: "Gratuito e Aberto:",
          text: "O WasOK é gratuito para todos usarem, sem planos premium ou paywalls",
        },
        {
          label: "Operação Enxuta:",
          text: "Mantemos nossos custos baixos criando software eficiente e focado em privacidade",
        },
        {
          label: "Doações Opcionais:",
          text: "Usuários que amam o WasOK podem nos apoiar por meio de doações voluntárias",
        },
        {
          label: "Código Aberto:",
          text: "Podemos oferecer consultoria ou serviços de desenvolvimento personalizado para organizações",
        },
      ],
    },
    noAffiliate: {
      title: "Sem Links de Afiliados",
      body: "O WasOK não usa links de afiliados nem recebe comissões de varejistas. Quando você escaneia um produto, não redirecionamos você para comprá-lo em nenhum lugar. O app é puramente para seu registro pessoal e tomada de decisões.",
    },
    noPromotions: {
      title: "Sem Promoção de Produtos",
      body: "Não aceitamos pagamento de marcas ou fabricantes para promover seus produtos. O WasOK nunca sugerirá produtos, destacará determinadas marcas ou influenciará suas avaliações de forma alguma. Suas opiniões são só suas.",
    },
    partnerships: {
      title: "Parcerias com Terceiros",
      body: "O WasOK não faz parceria com empresas de marketing, agregadores de dados ou redes de publicidade. Operamos de forma independente e priorizamos sua privacidade acima de tudo.",
    },
    future: {
      title: "Planos Futuros",
      body: "Estamos comprometidos em manter o WasOK livre de anúncios e focado em privacidade. Se algum dia precisarmos introduzir um modelo de negócios sustentável no futuro, nós:",
      items: [
        "Anunciaremos quaisquer mudanças com bastante antecedência",
        "Nunca comprometeremos a privacidade ou a segurança dos dados",
        "Sempre ofereceremos uma forma de usar o app sem rastreamento ou anúncios",
        "Ouviremos o feedback e as preocupações dos usuários",
      ],
    },
    supporting: {
      title: "Apoiando o WasOK",
      body: "Se você ama o WasOK e quer apoiar nossa missão de memória de compras focada em privacidade, você pode:",
      items: [
        "Contar aos seus amigos e familiares sobre o app",
        "Deixar uma avaliação positiva na Google Play Store",
        "Compartilhar seu feedback e sugestões conosco",
        "Considerar fazer uma doação voluntária (quando disponível)",
      ],
    },
    cta: {
      heading: "Dúvidas sobre nossas políticas?",
      body: "Somos transparentes sobre como o WasOK funciona. Se você tiver alguma dúvida sobre nossa abordagem à privacidade, monetização ou sustentabilidade, entre em contato.",
      button: "Fale Conosco",
    },
  },
};
